import React from 'react';
import { RENDERABLE } from '../Utils/propTypes';
import './style.scss';

const Body = ({ children }) => (
    <section className="modal-want-to-leave-body">{children}</section>
);

Body.propTypes = {
    children: RENDERABLE.isRequired
};

export default Body;
